export default {
  'AI Face Animator': 'AI Face Animator',
  'Create incredible facial expressions with brainwashing music, find the magic for fun.': 'Create incredible facial expressions with brainwashing music, find the magic for fun.',
  'Upload a photo': 'Upload a photo',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.': 'Note: please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.',
  'Uploaded successfully!': 'Uploaded successfully!',
  'Please select a template below': 'Please select a template below',
  'Choose a GIF': 'Choose a GIF',
  'Use this template': 'Use this template',
  'Verify successfully! You will': 'Verify successfully! You will receive the video with {{email}} soon.',
  'You will': 'You will receive the video with {{email}} soon.',
  'What you should expect to happen next': 'What you should expect to happen next:',
  'We will process your photo into a dynamic video.': 'We will process your photo into a dynamic video.',
  'After processing, we will send the video to your email.': 'After processing, we will send the video to your email.',
  'You can check the video in your email.': 'You can check the video in your email.',
  'Your video will be delivered via email': 'Your video will be delivered via email',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.': 'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.',
  'Your Email': 'Your Email',
  'Last Name': 'Last Name',
  'First Name': 'First Name',
  'Go back': 'Go back',
  'Invalid email address':'Invalid email address',
  'Enter verification code':'Enter verification code',
  'Enter the verification code that we sent to': 'Enter the verification code that we sent to {{email}}.',
  'Resend': 'Resend',
  'Verification code': 'Verification code',
  'Resend after': 'Resend after {{num}}s',
  'The verification code is invalid. You can request a new one.': 'The verification code is invalid. You can request a new one.',
  'Synthesize Video': 'Synthesize Video',
  'Too many attempts, please try again later.': 'Too many attempts, please try again later.',
}